import {
  RatingProps as MantineRatingProps,
  Rating as MantineRating,
} from '@mantine/core';

export type RatingProps = MantineRatingProps;

export const Rating = MantineRating;

Rating.displayName = 'Rating';
